(function () {
  function choice(form) {
    return form.querySelector('[data-aob-card-options] input[name="selling_plan"]:checked') ||
      form.querySelector('[data-aob-card-options] input[type="hidden"]');
  }

  function updateCard(form) {
    var options = form.querySelector('[data-aob-card-options]');
    var input = choice(form);
    var button = form.querySelector('[data-aob-card-submit]');
    if (!options || !button) return;
    var available = options.dataset.available === 'true' && !!input &&
      (options.dataset.requiresPlan !== 'true' || !!input.value);
    button.disabled = !available;
    button.textContent = available ? button.dataset.label + ' — ' + input.dataset.price : 'Sold out';
    var card = form.closest('.aob-pick__card, .aob-shop__card');
    if (input && card) {
      card.querySelectorAll('[data-aob-card-price]').forEach(function (el) { el.textContent = input.dataset.price; });
      card.querySelectorAll('[data-aob-card-unit]').forEach(function (el) { el.textContent = input.dataset.unit; });
    }
    var terms = options.querySelectorAll('[data-aob-plan-terms]');
    terms.forEach(function (el, index) {
      el.hidden = input && input.value ? el.dataset.aobPlanTerms !== input.value : index !== 0;
      el.querySelector('[data-aob-plan-prefix]').hidden = !!(input && input.value);
    });
  }

  document.addEventListener('change', function (event) {
    var form = event.target.closest('form');
    if (!form || !form.querySelector('[data-aob-card-purchase]')) return;
    if (event.target.matches('[data-aob-shopvar]')) {
      var selected = choice(form);
      var variant = form.querySelector('template[data-aob-card-variant="' + event.target.value + '"]');
      if (!variant) return;
      var previous = form.querySelector('[data-aob-card-options]');
      previous.replaceWith(variant.content.cloneNode(true));
      // Preserve an explicit purchase choice, including one-time. A variant
      // without purchase choices uses the new variant's subscription default.
      var replacement = selected && selected.type === 'radio' && (
        form.querySelector('[data-aob-card-options] input[value="' + selected.value + '"]') ||
        (selected.value && form.querySelector('[data-aob-card-options] input[type="radio"]:not([value=""])'))
      );
      if (replacement) replacement.checked = true;
      form.querySelector('input[name="id"]').value = event.target.value;
    }
    updateCard(form);
  });

  function init(root) {
    root.querySelectorAll('form:has([data-aob-card-purchase])').forEach(updateCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
